// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-tooltip__popper.info-tooltip{background:#f7f9fa;border:1px solid #eaeef1;border-radius:16px;font-weight:400;font-size:14px;line-height:140%;color:#6d7b8a;max-width:265px;padding:16px}.el-tooltip__popper.info-tooltip .popper__arrow{display:none}.el-tooltip__popper.info-tooltip span{white-space:pre-line;text-align:center;font-weight:400;font-size:14px;line-height:140%}.el-tooltip__popper.info-tooltip span b{color:#1c2734;font-weight:400}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
